export default "__VITE_ASSET__Cf5QgX7P__"